

<div class="auth-wrapper">
  <div class="auth-content col-md-5">
    <div class="card shadow p-3 mb-5 bg-white rounded">
      <div class="row align-items-center text-center">
        <div class="col-md-12">
          <div class="card-body px-3">

            <!--Header-->
            <img src="assets/images/IFSLogo.png" alt="" class="auth-logo mb-4">
            <h4 class="pb-4 f-w-400 text-center">Reset Password</h4>

            <!--Checking for updates-->
            <div *ngIf="isCheckingForUpdates" class="container mb-3">
              <h6>Checking for updates</h6>
              <div class="spinner-border" role="status"></div>
            </div>

            <!--Reset Password-->
            <div *ngIf="!isCheckingForUpdates" class="container">

              <!--Validation Summary-->
              <div *ngIf="errorMessageList.length > 0" class="alert alert-danger">
                <strong> Please correct the following:</strong>
                <ul class="m-0">
                  <li *ngFor="let errorMessage of errorMessageList">{{errorMessage}}</li>
                </ul>
              </div>

              <!--Reset Password-->
              <div *ngIf="!token" class="container">
                <div class="container">
                  <h6>Please enter the username that you want to reset the password</h6>
                </div>
                <div class="container">
                  <input type="text"
                         placeholder="Please enter the username"
                         class="form-control form-control-sm"
                         id="accountName"
                         [(ngModel)]="accountName"
                         (keydown.enter)="resetPassword()">
                </div>
                <div class="container">
                  <button class="btn btn-primary my-4 w-100" (click)="resetPassword()">Reset Password</button>
                </div>
              </div>

              <!--Change Password-->
              <div *ngIf="token" class="container">
                <!--New Password-->
                <div class="row">
                  <div class="col-5 px-0">
                    <label for="newPassword" class="col-form-label-sm">New Password</label>
                  </div>
                  <div class="col">
                    <input type="password"
                           class="form-control form-control-sm"
                           id="newPassword"
                           [(ngModel)]="newPassword">
                  </div>
                </div>
                <!--Confirm New Password-->
                <div class="row">
                  <div class="col-5 px-0">
                    <label for="confirmNewPassword" class="col-form-label-sm">Confirm Password</label>
                  </div>
                  <div class="col">
                    <input type="password"
                           class="form-control form-control-sm"
                           id="confirmNewPassword"
                           [(ngModel)]="confirmNewPassword"
                           (keydown.enter)="changePassword()">
                  </div>
                </div>
                <div class="container">
                  <button class="btn btn-primary my-4 w-100" (click)="changePassword()">Change Password</button>
                </div>
              </div>

            </div>

            <!--Back to login-->
            <div class="row">
              <a href="javascript:" (click)="goToLogin()"><span>Back to login?</span></a>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>

